{
  "header.create": "Create",
  "header.batch": "Batch",
  "header.privacyBadge": "Your data never leaves your browser",
  "header.offline": "Offline",
  "header.install": "Install",
  "header.language": "Language",
  "header.theme": "Theme",
  "theme.system": "System",
  "theme.light": "Light",
  "theme.dark": "Dark",
  "footer.privacy": "Your data never leaves your browser. All generation is done locally.",
  "layout.narrowWarning": "For the best experience, use a device with a screen width of at least 768 pixels.",
  "cancel": "Cancel",
  "save": "Save",
  "meta.title": "MamaJSON — Free QR Code Generator & Designer",
  "meta.description": "Create, customize, and download QR codes for free. No sign-up, no tracking — everything runs in your browser.",
  "header.brandName": "MamaJSON",
  "header.srTitle": "Free QR Code Generator - ",
  "header.feedback": "Feedback & Support",
  "qrupload.scan": "Scan",
  "qrupload.notFound": "No valid QR code found in the image."
}